import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components'
import '../assets/reset.css';
import '../assets/xeicon.min.css';
import '../assets/common.css';
import '../assets/fonts/NanumSquare-master/nanumsquare.css';
import 'github-markdown-css';
import Axios from 'axios';

const PAGE_CONTENT_NUMBER = 5;
const Container = styled.div`
    background-color:white;
    overflow:auto;
    padding:10px;
    display:flex;
    flex-direction: column;
    height:100%;
`;

const Top = styled.div`
    padding-bottom:10px;
    border-bottom:1px solid lightgrey;
`;

const Content = styled.div`
    position:relative;
    overflow:auto;
    flex:1;
`

export default function Update(props) {
    const [currentPage, setCurrentPage] = useState(0);
    const [searchState, setSearchState] = useState({ list: null, selectedName: null, searchValue: null });

    const currentContents = useMemo(() => {
        const start = PAGE_CONTENT_NUMBER * currentPage;
        const end = start + PAGE_CONTENT_NUMBER;
        const selectedName = searchState.selectedName;

        if (!!selectedName) {
            return props.pageContext.contents.filter(item => item.name === selectedName)
        } else {
            return props.pageContext.contents.slice(start, end);
        }
    }, [currentPage, props.pageContext.contents, searchState.selectedName])

    const changePage = useCallback((mod) => {
        const newPage = currentPage + mod;
        if (newPage < 0 || ((newPage) * PAGE_CONTENT_NUMBER >= props.pageContext.contents.length)) return;
        window.scrollTo(0, 0);
        setCurrentPage(newPage);
    }, [currentPage])

    const handleSearch = useCallback((val, inputValue) => {
        setSearchState(prev => ({ ...prev, list: val, searchValue: inputValue }));
    }, []);

    const handleClickSearchItem = useCallback((item) => {
        setSearchState(prev => ({ ...prev, list: null, selectedName: item.name }));
    }, []);

    const hanleCancel = useCallback(() => {
        setSearchState(prev => ({ ...prev, list: null, selectedName: null, searchValue: null }));
    }, [])

    return <Container>
        <Top>
            <Search onSearch={handleSearch} hasSearch={!!searchState.selectedName || searchState.list} onCancel={hanleCancel} />
        </Top>
        <Content>
            {!!searchState.list && <SearchList
                list={searchState.list}
                searchName={searchState.selectedName}
                searchValue={searchState.searchValue}
                onClickSearchItem={handleClickSearchItem} />}
            {!searchState.list && <>
                {
                    currentContents.map((content) => {
                        return <Item key={content.name} content={content} style={{ marginTop: 10 }} />
                    })
                }
                {
                    !searchState.selectedName && <Nav onClickPrev={() => {
                        changePage(-1);
                    }} onClickNext={() => {
                        changePage(1);
                    }} />
                }

            </>}
        </Content>
    </Container>
}


const StyledSearchBar = {
    Container: styled.div`
        
    `,
    InputArea: styled.div`
        text-align:right;
        
        & > * {
            display:inline-block;
        }
        &> input{
            padding:3px 6px;
        }
    `
}

function Search(props) {
    const { onSearch, hasSearch, onCancel, } = props;

    const S = StyledSearchBar;
    const inputRef = useRef();

    const handleClick = useCallback(() => {
        (async () => {
            const result = await Axios.request({
                method: "get",
                url: "https://doc.webworx.co.kr/api/update",
                params: {
                    query: inputRef.current.value
                }
            });

            onSearch(result.data, inputRef.current.value);
        })();
    }, [onSearch]);

    const handleKeydown = useCallback((event) => {
        if (event.keyCode === 13) {
            handleClick();
        }
    }, [handleClick]);

    return <S.Container>
        <S.InputArea>
            <div>업데이트 내역 검색 : </div>
            <input ref={inputRef} type="text" style={{ marginLeft: 10 }} onKeyDown={handleKeydown} onFocus={() => { inputRef.current.select(); }} />
            <button className="antd-style-button antd-style-button--primary" style={{ marginLeft: 5 }} onClick={handleClick}>검색하기</button>
            <button className="antd-style-button" disabled={!hasSearch} onClick={onCancel}>검색취소</button>
        </S.InputArea>
    </S.Container>
}


const SearchListStyled = {
    Container: styled.div`
        padding:10px;
        height:100%;
    `,
    Item: styled.div`
        border:1px solid lightgrey;
        margin:15px;
        cursor:pointer;
        &:hover{
            background-color:#f7f7f7;
        }

    `,
    ItemTitle: styled.div`
        padding:5px;
        // color:white;
        background-color:#fbfbfb;
        border-bottom: 1px solid lightgrey;
        ::before{
            content:'이름(또는 날짜) : '
        }
    `,
    ItemContent: styled.div`
        padding:10px;
        ::before{
            content:'내용 : '
        }
    `,
    Empty: styled.div`
        height:100%;
        width:100%;
        text-align:center;
        display:table;
    `,
    EmptyInner: styled.div`
        display:table-cell;
        vertical-align:middle;
    `
}
function SearchList(props) {
    const S = SearchListStyled;
    const { list, onClickSearchItem, searchName, searchValue } = props;

    const htmlList = useMemo(() => {
        return list.map(item => {
            return {
                key: item.name,
                name: item.item.name,
                data: item.item.data.replaceAll(searchValue, `<span style='color:#1890FF'>${searchValue}</span>`)
            }
        });
    }, [list, searchValue]);

    const handleClickItem = useCallback((item) => {
        onClickSearchItem(item);
    }, [onClickSearchItem]);

    return <S.Container>
        {htmlList.map(item => {
            return <S.Item key={item.key} onClick={() => { handleClickItem(item) }}>
                <S.ItemTitle>{item.name}</S.ItemTitle>
                <S.ItemContent style={{ pointerEvents: "none" }} dangerouslySetInnerHTML={{ __html: item.data }} />
            </S.Item>
        })}

        {
            !htmlList.length && <S.Empty><S.EmptyInner>"{searchValue}" 에 대한 검색 결과가 없습니다.</S.EmptyInner></S.Empty>
        }
    </S.Container>
}

const StyledItem = {
    Container: styled.div`
        /* padding:20px; */
        margin:20px;
        /* border:1px solid #f5f5f5; */
        display:flex;
        position:relative;
    `,
    Left: styled.div`
        min-width:160px;
        &::after{
            content:'';
            border-bottom:1px solid rgba(155,155,155,1);
            width:100%;
            left:0;
            position:absolute;
        }
    `,
    Right: styled.div`
        flex:1;
    `,
    Title: styled.div`
        text-align:left;
        font-size:1.1rem;
        padding:10px;
        display:flex;
        font-size:17px;
        font-weight:bolder;
    `,
    Content: styled.div`
        margin-top:20px;
        padding:10px;
        font-family:'NanumSquare';
    `,
    ContentTitle: styled.h3`
        font-size:15px;
        padding:10px;
        padding-top:14px;
        padding-left:0;
        font-size:lighter;
    `
}

function Item(props) {
    const S = StyledItem;
    const { content, style } = props
    const html = content.childMarkdownRemark.html;

    const dateString = useMemo(() => {
        const date = new Date(content.childMarkdownRemark.frontmatter.date);
        const day = { "0": "일", "1": "월", "2": "화", "3": "수", "4": "목", "5": "금", "6": "토" }[date.getDay()];
        return ` ${date.getFullYear()}. ${date.getMonth() + 1}. ${date.getDate()} [${day}]`
    }, [])

    {/* <span style="font-size:17px;color:rgba(74,74,74,1);font-family:'nanumsquare bold'">2020.06.30 [화]</span> */ }
    return <S.Container style={style}>
        <S.Left>
            <S.Title>
                {dateString}
            </S.Title>
        </S.Left>
        <S.Right>
            <S.ContentTitle>
                업데이트 내역
            </S.ContentTitle>
            <S.Content className="markdown-body">
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </S.Content>
        </S.Right>
    </S.Container>
}


const StyledNav = {
    Container: styled.div`
        text-align:center;
    `,
    A: styled.a`
        outline:none;
        box-shadow:none;
        cursor: pointer;
        &:hover{
            color:#95bbff;
        }
    `
}
function Nav(props) {
    const { onClickPrev, onClickNext } = props;
    const S = StyledNav;

    return <S.Container>
        <S.A onClick={onClickPrev}>이전</S.A>
        <S.A onClick={onClickNext} style={{ marginLeft: 10 }}>다음</S.A>
    </S.Container>
}